var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.688h-1.375v1.374H16.5v-1.374z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 5.5H2.75V3.437h15.125V2.063H2.75a1.375 1.375 0 0 0-1.375 1.374v14.438A1.375 1.375 0 0 0 2.75 19.25h16.5a1.375 1.375 0 0 0 1.375-1.375v-11A1.375 1.375 0 0 0 19.25 5.5zM2.75 17.875v-11h16.5v2.063h-5.5a1.375 1.375 0 0 0-1.375 1.374v4.126a1.375 1.375 0 0 0 1.375 1.374h5.5v2.063H2.75zm16.5-7.563v4.126h-5.5v-4.126h5.5z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsIcon);
export default __webpack_public_path__ + "static/media/paymentsIcon.3044b26c201ddda04bf34fb4baf311dc.svg";
export { ForwardRef as ReactComponent };